import React from "react";
import Box from "components/Box";
import styled from "styled-components";
import Row from "components/Row";

export default function QuestionPaper({
  keys,
  onQuestionChange,
  currentQuestionKey,
  progress = {},
  playedQuestions
}) {
  return (
    <Box
      boxShadow={10}
      padding="0"
      style={{ width: 300, margin: "0 10px", overflow: "hidden" }}
    >
      <DemoSection />
      <PickerContainer>
        {keys.map((key, i) => (
          <QuestionPickerButton
            key={key}
            onClick={() => onQuestionChange(key)}
            seen={playedQuestions.includes(key)}
            answered={Object.keys(progress).includes(key)}
            selected={currentQuestionKey === key}
          >
            {i + 1}
          </QuestionPickerButton>
        ))}
      </PickerContainer>
    </Box>
  );
}

function DemoSection() {
  return (
    <div
      style={{
        background: "#F8F8F8",
        padding: "20px 40px",
        textAlign: "center"
      }}
    >
      <span>
        This is a quick navigation to keep the track of progress of your
        questions
      </span>
      <Row margintop="15px" justify="space-around">
        <DemoCol>
          <QuestionPickerButtonDemo answered>X</QuestionPickerButtonDemo>
          Answered
        </DemoCol>
        <DemoCol>
          <QuestionPickerButtonDemo seen>X</QuestionPickerButtonDemo>
          Seen
        </DemoCol>
        <DemoCol>
          <QuestionPickerButtonDemo selected>X</QuestionPickerButtonDemo>
          Selected
        </DemoCol>
      </Row>
    </div>
  );
}

function getTextColor(props) {
  if (props.seen || props.answered) return "white";
  return "black";
}

function getBackgroundColor(props) {
  if (props.answered) return props.theme.palette.green;
  if (props.seen) return props.theme.palette.primary["500"];
  return "white";
}

const QuestionPickerButton = styled.button`
  border: 1px solid #ccca;
  background-color: ${getBackgroundColor};
  box-shadow: ${props =>
    props.selected
      ? "0 0 4px gold, 0 0 4px gold, 0 0 4px gold, 0 0 4px gold,0 0 4px gold"
      : "none"};
  width: 40px;
  height: 40px;
  font-size: 14px;
  line-height: 26px;
  margin: 0 6px 0px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 100;
  color: ${getTextColor};
  cursor: pointer;
  outline: 0;
  border-radius: 3px;
`;

const QuestionPickerButtonDemo = styled(QuestionPickerButton)`
  font-size: 24px;
  margin-bottom: 0;
  font-weight: 600;
`;

const DemoCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #4b5f78;
  line-height: 1.3;
`;

const PickerContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-flow: row wrap;
  max-height: 400px;
  overflow-y: scroll;
`;

// let ref = React.useRef();
// let buttonRef = React.useRef();

// function visible(el) {
//   var rect = el.getBoundingClientRect(),
//     top = rect.top,
//     height = rect.height,
//     el = el.parentNode;
//   // Check if bottom of the element is off the page
//   if (rect.bottom < 0) return false;
//   // Check its within the document viewport
//   if (top > document.documentElement.clientHeight) return false;
//   do {
//     rect = el.getBoundingClientRect();
//     if (top <= rect.bottom === false) return false;
//     // Check if the element is out of view due to a container scrolling
//     if (top + height <= rect.top) return false;
//     el = el.parentNode;
//   } while (el != document.body);
//   return true;
// }

// let scrollIntoViewIfNeeded = function(el, centerIfNeeded) {
//   centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

//   var parent = el.parentNode,
//     parentComputedStyle = window.getComputedStyle(parent, null),
//     parentBorderTopWidth = parseInt(
//       parentComputedStyle.getPropertyValue("border-top-width")
//     ),
//     parentBorderLeftWidth = parseInt(
//       parentComputedStyle.getPropertyValue("border-left-width")
//     ),
//     overTop = el.offsetTop - parent.offsetTop < parent.scrollTop,
//     overBottom =
//       el.offsetTop -
//         parent.offsetTop +
//         el.clientHeight -
//         parentBorderTopWidth >
//       parent.scrollTop + parent.clientHeight,
//     overLeft = el.offsetLeft - parent.offsetLeft < parent.scrollLeft,
//     overRight =
//       el.offsetLeft -
//         parent.offsetLeft +
//         el.clientWidth -
//         parentBorderLeftWidth >
//       parent.scrollLeft + parent.clientWidth,
//     alignWithTop = overTop && !overBottom;

//   if ((overTop || overBottom) && centerIfNeeded) {
//     parent.scrollTop =
//       el.offsetTop -
//       parent.offsetTop -
//       parent.clientHeight / 2 -
//       parentBorderTopWidth +
//       el.clientHeight / 2 +
//       20;
//   }

//   if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
//     el.scrollIntoView(alignWithTop);
//   }
// };

// React.useEffect(() => {
//   // let parent = ref.current;
//   // let button = buttonRef.current;
//   // let top =
//   //   (button.offsetHeight + 12) * Math.floor((+questionNumber - 1) / 5);

//   // parent.scrollTop = top;
//   // console.log(button.offsetHeight, questionNumber);
//   // console.log(top);
//   let item = document.getElementById(currentQuestionKey);
//   if (!visible(item)) {
//     scrollIntoViewIfNeeded(item);
//   }
// }, [currentQuestionKey]);
